<template>
    <div>
        <div v-if="hasCampaign" class="text-magenta text-xl text-center mt-4">
            Claim your {{ trialDays }} Day Free Trial
        </div>
        <attendee-login
            v-if="!attendee"
            v-on:login-success="hideModalAndGoToEvents"
            :data="data"
            class="mt-4"
        ></attendee-login>
    </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';

export default {
    props: {
        data: Object,
    },
    computed: {
        ...mapState(['attendee']),
        trialDays() {
            return this.data?.trial_days
        },
        hasCampaign() {
            return this.data?.campaign_id && this.trialDays
        }
    },
    methods: {
        ...mapMutations([`hideModal`]),
        hideModalAndGoToEvents() {
            this.hideModal()
            this.$root.redirect('/events')
        }
    }
}
</script>
